module.exports = __webpack_public_path__ + "b83ff4068823acb0c9ce1c3f9f359cef.svg";